(function () {
  function getBulkData(picker) {
    const script = picker.querySelector('[id^="variantBulkData-"]');
    if (!script) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return null;
    }
  }

  function getSavePrefix(picker) {
    return (picker.dataset.variantCardSavePrefix || 'Save').trim();
  }

  function getMoneyFormat() {
    return (window.MinimogSettings && window.MinimogSettings.money_format) || '${{amount}}';
  }

  function refreshVariantCards(picker) {
    const savePrefix = getSavePrefix(picker);
    const moneyFormat = getMoneyFormat();

    picker.querySelectorAll('.m-variant-card').forEach((card) => {
      const bulkSave = parseInt(card.getAttribute('data-bulk-save-cents'), 10) || 0;
      const effCompare = parseInt(card.getAttribute('data-effective-compare-cents'), 10) || 0;
      const priceCents = parseInt(card.getAttribute('data-variant-price-cents'), 10) || 0;
      const compareSave = effCompare > priceCents ? effCompare - priceCents : 0;
      const totalSave = Math.max(bulkSave, compareSave);

      const compareEl = card.querySelector('[data-variant-card-compare]');
      if (compareEl) {
        if (effCompare > priceCents) {
          compareEl.textContent = formatMoney(effCompare, moneyFormat);
          compareEl.classList.remove('m:hidden');
        } else {
          compareEl.textContent = '';
          compareEl.classList.add('m:hidden');
        }
      }

      const saveEl = card.querySelector('[data-variant-card-save]');
      if (!saveEl) return;

      if (totalSave > 0) {
        saveEl.textContent = savePrefix + ' ' + formatMoney(totalSave, moneyFormat);
        saveEl.classList.add('m-variant-card__save--active');
      } else {
        saveEl.textContent = '';
        saveEl.classList.remove('m-variant-card__save--active');
      }
    });
  }

  function applyBulkPricing(picker, variant) {
    const bulkData = getBulkData(picker);
    if (!bulkData || !variant) return;

    const entry = bulkData[String(variant.id)] || { bulkSave: 0, effectiveCompare: 0 };
    const effCompare = Math.max(entry.effectiveCompare || 0, variant.compare_at_price || 0);
    const bulkSave = entry.bulkSave || 0;
    const price = variant.price;
    const moneyFormat = getMoneyFormat();
    const savePrefix = getSavePrefix(picker);
    const onSale = effCompare > price;

    const productInfo = picker.closest('.m-product-info--wrapper') || document;
    const priceBlock = productInfo.querySelector('.main-product__block-price');
    if (!priceBlock) return;

    const priceWrapper = priceBlock.querySelector('.m-price');
    const saleCompare = priceBlock.querySelector('.m-price__sale .m-price-item--regular');
    const savedPriceEl = priceBlock.querySelector('[data-saved-price]');
    const bulkEl = priceBlock.querySelector('[data-bulk-save]');

    if (priceWrapper) {
      if (onSale) {
        priceWrapper.classList.add('m-price--on-sale');
      } else if (!variant.compare_at_price || variant.compare_at_price <= price) {
        priceWrapper.classList.remove('m-price--on-sale');
      }
    }

    if (saleCompare) {
      if (onSale) {
        saleCompare.innerHTML = formatMoney(effCompare, moneyFormat);
      }
    }

    if (savedPriceEl && priceWrapper) {
      const badgeType = priceWrapper.dataset.saleBadgeType || 'percentage';

      if (onSale && badgeType !== 'text') {
        if (badgeType === 'fixed_amount') {
          savedPriceEl.textContent = formatMoney(effCompare - price, moneyFormat);
        } else {
          savedPriceEl.textContent = Math.round((100 * (effCompare - price)) / effCompare) + '%';
        }
      }
    }

    if (bulkEl) {
      if (bulkSave > 0 && !onSale) {
        bulkEl.textContent = savePrefix + ' ' + formatMoney(bulkSave, moneyFormat);
        bulkEl.classList.remove('m:hidden');
      } else {
        bulkEl.textContent = '';
        bulkEl.classList.add('m:hidden');
      }
    }

    refreshVariantCards(picker);
  }

  function initPicker(picker) {
    const bulkData = getBulkData(picker);
    if (!bulkData) return;

    const productId = picker.dataset.productId;
    if (!productId || !window.MinimogEvents) return;

    const runForVariant = (variant) => {
      if (!variant) return;
      requestAnimationFrame(() => applyBulkPricing(picker, variant));
    };

    window.MinimogEvents.subscribe(`${productId}__VARIANT_CHANGE`, runForVariant);

    const variantInput =
      picker.closest('.m-product-info--wrapper')?.querySelector('[name="id"]:not([disabled])') ||
      picker.closest('form')?.querySelector('[name="id"]');

    if (variantInput && variantInput.value) {
      const variantId = variantInput.value;
      const productData = (window._themeProducts || {})[productId];
      const variant = productData?.variants?.find((item) => String(item.id) === String(variantId));
      runForVariant(variant);
    } else {
      refreshVariantCards(picker);
    }
  }

  function init() {
    document.querySelectorAll('[data-variant-picker]').forEach(initPicker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', () => {
    requestAnimationFrame(init);
  });
})();
